<script>
import BaseView from "@/mixins/BaseView.vue";
import { mapActions, mapState } from "pinia";
import { useAppStore } from "@/store/app.store.ts";
import { useSnackbarStore } from "@/store/snackbar.store.ts";
import { useDateTime } from "@/composables/index.ts";
import TimezoneSelect from "@/components/selects/TimezoneSelect.vue";

const { timezonesList } = useDateTime();

export default {
  name: "AccountProfile",
  components: { TimezoneSelect },
  mixins: [BaseView],
  data() {
    return {
      perms: "account",
      timezone: null,
    };
  },
  computed: {
    ...mapState(useAppStore, ["dispatcher"]),
    timezonesList() {
      return timezonesList;
    },
  },
  watch: {
    dispatcher: {
      handler(value) {
        if (value) {
          this.timezone = value.timezone;
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(useSnackbarStore, ["showSnackbarSuccess"]),
    async save() {
      const dispatcher = { ...this.dispatcher, timezone: this.timezone };
      await this.$api.dispatchers.upsertDispatcher(dispatcher);
      this.showSnackbarSuccess(this.$t("general.saved"));
    },
  },
};
</script>

<template>
  <v-container fluid>
    <v-card class="w-100">
      <v-card-title>Profile</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <timezone-select
              v-model="timezone"
              :items="timezonesList"
              color="primary"
              density="compact"
              item-title="name"
              item-value="id"
              label="Timezone"
              show-full-timezone
              variant="outlined"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="success" small @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
